export default function CenterPanel() {
  return (
    <div className="Center-panel">
      <h2>Center Panel</h2>
      <p>Content for the center panel goes here.</p>
    </div>
  );
}
